import { CampaignDetailsResponse } from '../../api-models';
import { DisplayCampaignInformation } from '../../types/campaigns.type';
import { CampaignStatus, HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import { formatDateToString, formatSnapshot } from '../../utils/formatters';

import BaseAdapter from './baseAdapter';

export default class GetAllCampaigns extends BaseAdapter<CampaignDetailsResponse[]> implements AdapterInterface {
  rawResponse: CampaignDetailsResponse[];

  async adaptResponse(): Promise<DisplayCampaignInformation[]> {
    await this.fetchApiResponse('/api/all-campaigns', HTTPMethod.Get);
    return this.displayResponse();
  }

  async displayResponse(): Promise<DisplayCampaignInformation[]> {
    // TODO: 4957: implement functionality to cancel/archive campaigns from the frontend.
    const activeCampaigns = this.rawResponse.filter((campaign) => campaign.status !== CampaignStatus.Archived);
    return activeCampaigns.map((campaign: CampaignDetailsResponse) => ({
      campaignName: campaign.name,
      numberOfRecipients: campaign.number_of_recipients,
      snapshot: formatSnapshot(campaign.snapshot, 'long'),
      rawSnapshot: campaign.snapshot,
      campaignType: campaign.benefit_name ? campaign.benefit_name.split('_').join(' ') : 'custom',
      communicationChannel: campaign.channel,
      createdBy: campaign.created_by,
      reviewed: campaign.reviewed,
      dateSent: campaign.date_sent ? formatDateToString(new Date(campaign.date_sent)) : '',
      status: campaign.status,
      campaignCommunicationId: campaign.campaign_communication_id,
    }));
  }
}
